import { IBreadcrumb } from '../../types/breadcrumbs';

export function breadcrumbsReducer(state: IBreadcrumb[]): IBreadcrumb[] {
  return state || [];
}
